// removed by extract-text-webpack-plugin
module.exports = {"card-container":"card-container_HotCard","cardContainer":"card-container_HotCard","image-feed":"image-feed_HotCard","imageFeed":"image-feed_HotCard","image":"image_HotCard","title-box":"title-box_HotCard","titleBox":"title-box_HotCard","title":"title_HotCard","comment-box":"comment-box_HotCard","commentBox":"comment-box_HotCard","item":"item_HotCard","feed-title":"feed-title_HotCard","feedTitle":"feed-title_HotCard","count":"count_HotCard","counts":"counts_HotCard","count-label":"count-label_HotCard","countLabel":"count-label_HotCard","clear":"clear_HotCard"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeTop/HotCard/HotCard.scss
// module id = 121
// module chunks = 0